import React from "react";
import {
  Table,
  NumberInput,
  Button,
  ActionIcon,
} from "@mantine/core";
import _ from "lodash";
import { IconTrash } from "@tabler/icons";

const DEFAULT_BAND = {
  minPayYears: 1,
  maxPayYears: 1,
  multiplier: 0.1,
};

const PointPayYearBands = ({ form: mainForm, name = "payYearBands" }) => {
  const bands = _.get(mainForm.values, name) || [];

  const updateForm = (next) => {
    mainForm.setFieldValue(name, next);
  };

  const handleChange = (index, field, value) => {
    const next = bands.map((row, rowIndex) =>
      rowIndex === index ? { ...row, [field]: value } : row
    );
    updateForm(next);
  };

  const handleRemove = (index) => {
    updateForm(bands.filter((_, rowIndex) => rowIndex !== index));
  };

  const handleAdd = () => {
    const last = bands[bands.length - 1];
    updateForm([
      ...bands,
      last
        ? {
            minPayYears: (last.maxPayYears || last.minPayYears || 0) + 1,
            maxPayYears: null,
            multiplier: last.multiplier,
          }
        : { ...DEFAULT_BAND },
    ]);
  };

  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>Min Years</th>
            <th>Max Years</th>
            <th>Multiplier %</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {bands.map((band, index) => (
            <tr key={index}>
              <td>
                <NumberInput
                  min={1}
                  value={band.minPayYears}
                  onChange={(value) =>
                    handleChange(index, "minPayYears", value)
                  }
                />
              </td>
              <td>
                <NumberInput
                  min={1}
                  placeholder="Open"
                  value={band.maxPayYears ?? undefined}
                  onChange={(value) =>
                    handleChange(
                      index,
                      "maxPayYears",
                      value === "" || value == null ? null : value
                    )
                  }
                />
              </td>
              <td>
                <NumberInput
                  min={0}
                  precision={2}
                  value={Math.round((band.multiplier || 0) * 10000) / 100}
                  onChange={(value) =>
                    handleChange(index, "multiplier", (value || 0) / 100)
                  }
                />
              </td>
              <td>
                <ActionIcon size="xs" onClick={() => handleRemove(index)}>
                  <IconTrash />
                </ActionIcon>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Button size="xs" onClick={handleAdd} mt="xl">
        Add
      </Button>
    </>
  );
};

export default PointPayYearBands;
